/* istanbul ignore file */
/* tslint:disable */
import { oneOf as codecOneOf } from 'purify-ts/Codec';
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { HasUnreadNotifcationJSON, Notification, NotificationsJSON, PatchAllNotificationData, PatchNotificationData, } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
import { makeResponses } from '../response_factory';
const makeResult = coreUtils.makeResult;
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function notification(config) {
    const getAllResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(
        /* #__PURE__ */ codecOneOf([NotificationsJSON, HasUnreadNotifcationJSON]))),
    });
    const patchAllResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(NotificationsJSON)),
    });
    const patchResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parseJsonResponse(Notification)),
    });
    return Object.freeze({
        /**
         * Get all notifications for the current user.
         *
         * @param arg The arguments to the function.
         * @param arg.hasUnread If considered true a short digest will be sent, i.e. a single object with one key `has_unread` with a boolean value. Please use this if you simply want to check if there are unread notifications.
         * @returns Either a list of notifications or a `HasUnreadNotifcationJSON` based on the `has_unread` query parameter.
         */
        getAll: async ({ hasUnread = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/notifications/`, getAllResponse.v, undefined, {
                has_unread: hasUnread,
            });
            return result;
        },
        /**
         * Update the read status of multiple notifications.
         *
         * @param arg The arguments to the function.
         * @param arg.requestBody The body of the request.
         * @returns The updated notifications in the same order as given in the body.
         */
        patchAll: async ({ requestBody, }) => {
            const result = await requestParams(config, 'PATCH', `/api/v1/notifications/`, patchAllResponse.v, JSON.stringify(PatchAllNotificationData.encode(requestBody)));
            return result;
        },
        /**
         * Update the read status for the given notification.
         *
         * @param arg The arguments to the function.
         * @param arg.notificationId The id of the notification to update.
         * @param arg.requestBody The body of the request.
         * @returns The updated notification.
         */
        patch: async ({ notificationId, requestBody, }) => {
            const result = await requestParams(config, 'PATCH', `/api/v1/notifications/${notificationId}`, patchResponse.v, JSON.stringify(PatchNotificationData.encode(requestBody)));
            return result;
        },
    });
}
